import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { fetchApi } from "./redux/api";
import { formatNumber } from "./redux/utils";

function Shedule8() {
  const [overhead, setOverhead] = useState([]);

  useEffect(() => {
    fetchApi(`get_cash_report?query_type=shedule&code=1101`)
      .then((data) => {
        console.log(data);
        setOverhead(data.result);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [])

  return (
    <div>
      <div className="container-fluid">
        {/* {JSON.stringify(overhead)} */}
        <div
          className="header"
          style={{
            background: "linear-gradient(to right, #bc5449, white)",
            padding: "40px 50px 2px 50px",
            borderBottom: "4px solid #2E8B57",
            marginBottom: "15px",
            display: "flex",
            textAlign: "center",
          }}
        >
          <p
            className=""
            style={{ textTransform: "uppercase", textAlign: "right" }}
          >
            report of the accountant general with IPSAS accrual financial
            statement for the year ended 31st December, 2023
          </p>
        </div>
        <h1
          style={{
            fontSize: "24px",
            textAlign: "left",
            color: "#2E8B57",
          }}
        >
          Schedule 8: OVERHEAD COST AND RECURRENT EXPENDITURE
        </h1>
        {/* <h5
          className="text-center"
          style={{ fontWeight: "bold", marginTop: "30px", fontSize: "15PX" }}
        ></h5> */}
        <Table bordered responsive className="border-bold">
          <thead>
            <tr>
              <th style={{ borderLeft: "none" }}>Code</th>
              <th style={{ textAlign: "center" }}>MDAs</th>
              <th>ACTUAL EXPENDITURE</th>
              <th>APPROVED BUDGET 2023</th>
              <th>2023 REVISED BUDGET</th>
              <th>VARIANCE</th>
              <th>PERFORMANCE%</th>
            </tr>
          </thead>
          <tbody>
            {overhead?.map((row, index) => (
              <tr key={index}>
                <td style={{ borderLeft: "none" }}>{row.admin_code}</td>
                <td style={{  width: "100%" }}>
                  {row.admin_description}
                </td>
                <td style={{ textAlign: "right" }}>
                  {Math.sign(row.actual) === -1
                    ? `(${formatNumber(row.actual)})`
                    : row.actual === 0
                      ? "-"
                      : formatNumber(row.actual)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {Math.sign(row.approved) === -1
                    ? `(${formatNumber(row.approved)})`
                    : row.approved === 0
                      ? "-"
                      : formatNumber(row.approved)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {Math.sign(row.revised) === -1
                    ? `(${formatNumber(row.revised)})`
                    : row.revised === 0
                      ? "-"
                      : formatNumber(row.revised)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {Math.sign(row.variance) === -1
                    ? `(${formatNumber(Math.abs(row.variance))})`
                    : row.variance === 0
                      ? "-"
                      : formatNumber(row.variance)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {row.performance !== null ? row.performance?.toFixed(2) + '%' : ''}
                </td>
              </tr>
            ))}
            <tr style={{ fontWeight: "bold" }}>
              <td style={{ textAlign: "center" }}>Total</td>
              <td></td>
              <td style={{ textAlign: "right" }}>
                {formatNumber(
                  overhead?.reduce((sum, item) => sum + item.actual, 0)
                )}
              </td>
              <td style={{ textAlign: "right" }}>
                {formatNumber(
                  overhead?.reduce((sum, item) => sum + item.approved, 0)
                )}
              </td>
              <td style={{ textAlign: "right" }}>
                {formatNumber(
                  overhead?.reduce((sum, item) => sum + item.revised, 0)
                )}
              </td>
              <td style={{ textAlign: "right" }}>
                {Math.sign(
                  overhead?.reduce((sum, item) => sum + item.variance, 0)
                ) === -1
                  ? `(${formatNumber(
                      overhead?.reduce((sum, item) => sum + item.variance, 0)
                    )})`
                  : formatNumber(Math.abs(
                      overhead?.reduce((sum, item) => sum + item.variance, 0))
                    )}
              </td>
              <td style={{ textAlign: "right" }}>
                {(
                  overhead?.reduce((sum, item) => sum + item.performance, 0) /
                  100
                ).toFixed(2)}
                %
              </td>
            </tr>
          </tbody>
        </Table>
        <div
          className="footer"
          style={{
            background: "linear-gradient(to right, #420D09, #990f02)",
            padding: "20px",
          }}
        >
          <p
            style={{ background: "#fff", width: "30px" }}
            className="text-center"
          >
            96
          </p>
        </div>
      </div>
    </div>
  );
}

export default Shedule8;
